import { render } from "./PrivacyPolicy.vue?vue&type=template&id=4a3da4c1"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__